<template>
  <div id="root">
    <div class="order-wrap">
      <div class="order-status order-block">
        <div class="order-status-box">
          <div class="order-status-content">
            <div class="order-block-title">{{STATUS[info.status]}}</div>
          </div>
          <div class="order-item-btns" style="align-items: end;" v-if="info.status == 5">
            <button @click="onReceipt(info)" type="button" class="comet-btn comet-btn-primary comet-btn-block order-item-btn" style="margin: 0;">
              <span data-spm-anchor-id="a2g0o.order_list.order_list_main.i0.14781802mXqv5e">{{$t('detail.receipt')}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="order-detail-info">
        <div class="order-detail-info-item">
          <span class="comet-icon comet-icon-address ">
            <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
              <path d="M515.16701 76.324948c206.72132 0 362.094845 144.215093 362.094846 351.749279 0 67.985155-26.180619 143.497237-78.235712 227.000742l-6.376247 10.060536a989.775175 989.775175 0 0 1-39.482062 56.700041l-7.980866 10.556701-4.085443 5.320578-8.360907 10.672824c-2.829196 3.578722-5.700619 7.168-8.603712 10.767836l-8.846515 10.831175-4.518268 5.447258-9.226557 10.947298-9.469361 11.031753-4.824412 5.552825-9.838846 11.147876-5.014433 5.605608-10.208329 11.274557-5.193897 5.658392-10.588371 11.401237-5.383918 5.711175-10.947299 11.506804c-1.836866 1.931876-3.694845 3.863753-5.563381 5.795629l-11.316784 11.622928-11.570144 11.717938-11.812949 11.781278-12.055752 11.876289-12.298557 11.950186a72.429526 72.429526 0 0 1-100.615918-0.03167l-6.059546-5.869526-12.055752-11.791835c-1.995216-1.95299-3.96932-3.905979-5.943423-5.869526l-11.696825-11.675711-5.763959-5.806186-11.337897-11.559588-11.095092-11.475134c-1.836866-1.900206-3.652619-3.800412-5.457815-5.700618L384.686186 848.86433l-10.493361-11.285114-5.162227-5.605608-10.134433-11.168989-9.881072-11.084537-9.648825-11.010639-4.729402-5.478928-9.289897-10.894515-9.036536-10.810062c-2.97699-3.589278-5.911753-7.178557-8.804289-10.746722l-8.550928-10.662268a1277.994227 1277.994227 0 0 1-4.19101-5.299463l-8.192-10.556701-7.949196-10.461691C195.130062 612.499794 153.072165 514.248577 153.072165 428.074227 153.072165 220.540041 308.445691 76.324948 515.16701 76.324948z m0 62.073403c-173.425485 0-300.021443 117.496082-300.021443 289.675876 0 26.59233 5.225567 55.296 15.708371 86.068783l2.850309 8.075877a471.230021 471.230021 0 0 0 24.364866 54.757608l4.644949 8.772618c17.47134 32.335175 39.767093 66.538887 66.918928 102.558351l7.516371 9.859959 7.769732 9.965525 8.001979 10.039423 8.25534 10.134433 8.487588 10.24 8.730392 10.313897 4.454928 5.18334 9.078762 10.451134 9.342681 10.546145 9.574928 10.620041 9.817732 10.725608 4.993319 5.383918 10.187217 10.852288 10.419464 10.936743 10.662268 11.021195c1.794639 1.847423 3.599835 3.694845 5.426144 5.542268l11.021196 11.158433 11.274557 11.242887 5.721732 5.658392 11.633484 11.369567 5.975093 5.795629a10.345567 10.345567 0 0 0 14.378227 0l5.848412-5.668949 11.517361-11.264 5.668948-5.595051 11.16899-11.13732 10.926186-11.052866 5.383917-5.489484 10.556701-10.915629 10.345567-10.841732 5.067217-5.383918 9.986639-10.704495 9.733278-10.620041c1.604619-1.752412 3.19868-3.515381 4.782186-5.27835l9.395464-10.482805 4.592165-5.204453 9.036536-10.366681c2.966433-3.430928 5.901196-6.861856 8.793732-10.261113l8.550928-10.187216c1.414598-1.689072 2.808082-3.378144 4.19101-5.067217l8.202557-10.039423 7.970309-9.965525 7.727505-9.870516c3.800412-4.919423 7.526928-9.796619 11.158433-14.652701l7.13633-9.648825 6.904082-9.564371 6.671835-9.479917a876.734021 876.734021 0 0 0 12.636372-18.685361l5.953979-9.205443a724.780866 724.780866 0 0 0 16.47901-27.088495l5.02499-8.846516c2.449155-4.402144 4.813856-8.772619 7.094103-13.111422l4.433814-8.614268c1.446268-2.860866 2.850309-5.700619 4.201567-8.540372l3.96932-8.44536c21.176742-46.164454 31.722887-88.211794 31.722887-125.994227 0-172.179794-126.595959-289.675876-300.021444-289.675876z m8.867629 124.146804c90.650392 0 164.051134 73.918021 164.051134 164.980123 0 91.07266-73.400742 164.99068-164.051134 164.990681S359.983505 518.597938 359.983505 427.525278c0-91.062103 73.400742-164.980124 164.051134-164.980123z m0 62.073402c-56.267216 0-101.977732 46.027216-101.977732 102.906721 0 56.890062 45.710515 102.917278 101.977732 102.917279s101.977732-46.027216 101.977732-102.917279c0-56.879505-45.710515-102.906722-101.977732-102.906721z">
              </path>
            </svg>
          </span>
          <div class="order-detail-info-content has-switch">
            <div class="contact-info">{{info.u_contact}}</div>
            <div>{{info.u_phone}}</div>
            <div>{{info.u_address}}</div>
          </div>
        </div>
        <div class="order-detail-info-item order-detail-order-info">
          <span class="comet-icon comet-icon-orders ">
            <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
              <path d="M640 85.333333a96.042667 96.042667 0 0 1 90.538667 64H778.666667c63.776 0 115.658667 50.88 117.290666 114.261334L896 266.666667v554.666666c0 63.776-50.88 115.658667-114.261333 117.290667L778.666667 938.666667H245.333333c-63.776 0-115.658667-50.88-117.290666-114.261334L128 821.333333V266.666667c0-63.776 50.88-115.658667 114.261333-117.290667L245.333333 149.333333h48.128A96.042667 96.042667 0 0 1 384 85.333333z m90.538667 128A96.042667 96.042667 0 0 1 640 277.333333H384a96.042667 96.042667 0 0 1-90.538667-64H245.333333a53.333333 53.333333 0 0 0-53.28 51.018667L192 266.666667v554.666666a53.333333 53.333333 0 0 0 51.018667 53.28L245.333333 874.666667h533.333334a53.333333 53.333333 0 0 0 53.28-51.018667L832 821.333333V266.666667a53.333333 53.333333 0 0 0-51.018667-53.28L778.666667 213.333333zM560 682.666667a32 32 0 0 1 0 64H330.666667a32 32 0 0 1 0-64h229.333333zM693.333333 533.333333a32 32 0 0 1 0 64H330.666667a32 32 0 0 1 0-64h362.666666z m0-149.333333a32 32 0 0 1 0 64H330.666667a32 32 0 0 1 0-64h362.666666z m-53.333333-234.666667H384a32 32 0 0 0 0 64h256a32 32 0 0 0 0-64z"></path>
            </svg>
          </span>
          <div class="order-detail-info-content">
            <div class="info-row">
              <span class="order-detail-gray ">
                {{$t('member.order.id')}} ID:&nbsp;
              </span>
              {{info.order_sn}}
              <button type="button" class="comet-btn comet-btn-link">
                <span>{{$t('member.order.cpoy')}}</span>
              </button>
            </div>
            <div class="info-row">
              <span class="order-detail-gray">
                {{$t('member.order.date')}}:&nbsp;
              </span>
              {{info.create_time}}
            </div>
          </div>
        </div>
      </div>
      <div class="order-detail-item">
        <div class="order-detail-item-store">
          <a target="_blank" href="javascript:" rel="noreferrer">
            <img class="store-icon" src="@/static/img/store.png" alt="">
            <span class="store-name">{{info.store && info.store.name}}</span><span class="comet-icon comet-icon-arrowright store-arrow">
              <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                <path d="M318.698667 97.6a35.925333 35.925333 0 0 1 49.813333-4.128l1.632 1.408 371.914667 355.232a85.333333 85.333333 0 0 1 0.032 123.381333L370.133333 929.12a35.936 35.936 0 0 1-51.445333-2.730667 37.674667 37.674667 0 0 1 1.130667-50.944l1.546666-1.504L685.653333 527.253333a21.333333 21.333333 0 0 0 0-30.922666L321.365333 150.058667a37.653333 37.653333 0 0 1-2.666666-52.448z"></path>
              </svg>
            </span>
          </a>
          <router-link :to="{name:'message',query:{code:info.store && info.store.sid}}">
            <span class="comet-icon comet-icon-message store-message">
              <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                <path d="M602.453333 128c90.581333 0 175.498667 37.173333 238.122667 101.984C907.072 298.805333 938.666667 372.405333 938.666667 474.88c0 106.496-35.52 200.917333-98.389334 265.994667-62.624 64.821333-147.541333 101.994667-238.122666 101.994666H475.381333A538.133333 538.133333 0 0 0 326.005333 864l-109.664 31.68a53.12 53.12 0 0 1-66.752-61.792l21.909334-105.770667-2.08-2.432c-52.949333-62.677333-82.848-148.48-84.053334-244.778666L85.333333 474.869333c0-102.464 31.594667-176.064 98.090667-244.885333C246.048 165.173333 330.965333 128 421.546667 128z m0 64H421.546667c-72.96 0-141.354667 29.941333-192.096 82.453333C174.165333 331.68 149.333333 389.514667 149.333333 474.88c0 90.805333 29.152 169.077333 79.818667 221.514667a32 32 0 0 1 8.32 28.736l-21.568 104.053333 92.341333-26.666667a602.133333 602.133333 0 0 1 157.717334-23.584l9.418666-0.074666h126.773334c72.96 0 141.354667-29.941333 192.096-82.453334C845.184 643.669333 874.666667 565.28 874.666667 474.858667c0-85.354667-24.832-143.189333-80.117334-200.416-50.741333-52.512-119.146667-82.453333-192.106666-82.453334zM704 448a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z m-192 0a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z m-192 0a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z">
                </path>
              </svg>
            </span>
          </router-link>
        </div>
        <!-- 商品详情 -->
        <div v-for="(item,i) in info.detail" :key="i" class="order-detail-item-content-wrap">
          <div class="order-detail-item-content">
            <a target="_blank" class="order-detail-item-content-img" href="javascript:" rel="noreferrer" :style="'background-image: url('+item.img+');'">
              <div class="order-detail-item-snapshot">
                <span class="comet-icon comet-icon-cameraline " style="font-size: 12px;"><svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
                    <path d="M625.226667 128c47.776 0 90.741333 29.088 108.48 73.450667l0.938666 2.197333A52.842667 52.842667 0 0 0 782.773333 234.666667H821.333333c64.8 0 117.333333 52.533333 117.333334 117.333333v426.666667c0 64.8-52.533333 117.333333-117.333334 117.333333H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V352c0-64.8 52.533333-117.333333 117.333334-117.333333h38.56a52.842667 52.842667 0 0 0 49.066666-33.216l1.216-2.933334A116.842667 116.842667 0 0 1 398.773333 128z m0 64h-226.453334a52.842667 52.842667 0 0 0-49.066666 33.216l-1.216 2.933333A116.842667 116.842667 0 0 1 241.226667 298.666667H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333333v426.666667a53.333333 53.333333 0 0 0 53.333334 53.333333h618.666666a53.333333 53.333333 0 0 0 53.333334-53.333333V352a53.333333 53.333333 0 0 0-53.333334-53.333333h-38.56c-47.776 0-90.741333-29.088-108.48-73.450667l-0.938666-2.197333A52.842667 52.842667 0 0 0 625.226667 192zM512 341.333333c106.037333 0 192 85.962667 192 192s-85.962667 192-192 192-192-85.962667-192-192 85.962667-192 192-192z m0 64c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128z m256-42.666666a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z">
                    </path>
                  </svg>
                </span>
              </div>
            </a>
            <div class="order-detail-item-content-info">
              <div class="item-title">
                <router-link :to="{name:'detail',query:{id:item.goods_id}}">{{item.name}}</router-link>
              </div>
              <div class="item-sku-attr">
                <span v-for="(svo,sk) in item.sku" :key="sk" style="margin-right: 5px;">{{sk}}:{{ svo }}</span>
              </div>
              <div class="item-price">${{item.price}}<span>x{{item.num}}</span></div>
              <div class="item-tags">
                <span class="order-item-tag" style="cursor: pointer;">
                  <img src="@/static/img/dun.png">
                </span>
                <span style="color: #01a971">{{$t('detail.free.shipping')}}</span>
              </div>
            </div>
            <!-- 评论按钮 -->
            <div class="order-item-btns" v-if="info.status == 2 && item.is_comment == 1">
              <button @click="onComment(item)" type="button" class="comet-btn comet-btn-primary comet-btn-block order-item-btn">
                <span data-spm-anchor-id="a2g0o.order_list.order_list_main.i0.14781802mXqv5e">{{$t('detail.comment')}}</span>
              </button>
            </div>
          </div>
        </div>

      </div>
      <div class="order-price">
        <div class="order-price-item">
          <span class="left-col">{{$t('confirm.total.item.costs')}} &nbsp;</span>
          <span class="right-col right-gap" style="color: rgb(153, 153, 153);">${{info.sub_total}}</span>
        </div>
        <div class="order-price-item">
          <span class="left-col bold-font">{{$t('confirm.total')}} &nbsp;</span>
          <span class="right-col bold-font right-gap" style="color: rgb(34, 34, 34);">${{info.total}}&nbsp;&nbsp;</span>
        </div>
        <!-- <span class="comet-icon comet-icon-arrowdown switch-icon">
          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="false" focusable="false">
            <path d="M97.6 308.032a35.925333 35.925333 0 0 0-4.128 49.813333l1.408 1.632 355.232 371.914667a85.333333 85.333333 0 0 0 123.381333 0.032l355.626667-371.946667a35.936 35.936 0 0 0-2.730667-51.445333 37.674667 37.674667 0 0 0-50.944 1.130667l-1.504 1.546666L527.253333 674.986667a21.333333 21.333333 0 0 1-30.922666 0L150.058667 310.698667a37.653333 37.653333 0 0 0-52.448-2.666667z"></path>
          </svg>
        </span> -->
      </div>
    </div>
  </div>
  <!-- 评论 -->
  <Comment ref="comment" @onOk="onCommentOk"></Comment>

  <!-- 确认收货 -->
  <Confirm ref="confirm" :title="msgTitle" :content="msgContent" @onOk="onReceiptOk"></Confirm>
</template>

<script>

import Comment from "@/components/member/Comment.vue";
import Confirm from "@/components/member/Confirm";
export default {
  name: "orderDetail",
  components: {
    Comment,
    Confirm,
  },
  data () {
    return {
      STATUS: {
        0: "Unkonw",
        '-1': this.$t('member.order.refund'),
        1: this.$t('member.order.unpaid'),
        2: this.$t('member.order.completed'),
        3: this.$t('member.order.procurement'),
        4: this.$t('member.order.processing'),
        5: this.$t('member.order.shipped'),
      },
      order_sn: "",
      info: {},

      //消息内容
      msgTitle: "",
      msgContent: "",
      msgRecord: {},
    };
  },
  created () {
    //参数
    this.order_sn = this.$route.query.order_sn;

    this.getOrderDetail();
  },
  methods: {
    getOrderDetail () {
      //接口
      let that = this;
      this.$api.user
        .getOrderDetail({
          order_sn: this.order_sn,
        })
        .then((res) => {
          that.info = res.data;
          console.log(res);
        });
    },
    /**
     * 参与评论
     * @param {*} item
     */
    onComment (item) {
      this.$refs.comment.open(item.id);
    },
    onCommentOk () {
      this.getOrderDetail();
    },
    /**
     * 确认收货
     */
    onReceipt (record) {
      this.msgRecord = record;
      this.msgTitle = "Confirm receipt of the order?";
      this.msgContent =
        "After confirmation, the transaction order is completed.";
      this.$refs.confirm.open();
    },
    onReceiptOk () {
      let that = this;
      this.$message.loading({ content: "Receipt order...", key: "msg" });
      this.$api.order.receipt({ id: this.msgRecord.id }).then((res) => {
        that.$message.success({
          content: res.msg,
          key: "msg",
        });
        that.$refs.confirm.hide();
        that.getOrderDetail();
      });
    },
  },
};
</script>
<style scoped src="@/static/css/order-detail.css"></style>